import { InvoiceStatus } from '@rematter/frontend-lib-api-client/grpc/finance/v1/domain_pb';
import { InvoiceDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/finance/v1/invoice_events_pb';
import { BadgeField, Col, FieldDisplay, ThemeColor } from '@rematter/ui-web';

import { invoiceStatusLabels, invoiceTypeLabels } from '../enumLabels';

import { useTranslations } from '@/finance/i18n/useTranslations';

const getStatusColor = (status: InvoiceStatus): ThemeColor => {
  switch (status) {
    case InvoiceStatus.PROFORMA:
      return 'neutral';
    case InvoiceStatus.PENDING:
      return 'warning';
    case InvoiceStatus.PAID:
      return 'success';
    case InvoiceStatus.VOIDED:
      return 'failure';
    default:
      return 'neutral';
  }
};

type InvoiceDeletedDetailProps = {
  event: InvoiceDeletedEvent;
};

export const InvoiceDeletedDetail = ({ event }: InvoiceDeletedDetailProps) => {
  const t = useTranslations();
  const invoice = event.invoice;

  if (!invoice) {
    return (
      <Col className="@InvoiceDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  const formatAmount = () => {
    if (!invoice.amount) return 'N/A';
    const value = Number(invoice.amount.amount) / 100;
    return `${invoice.amount.currency} ${value.toFixed(2)}`;
  };

  return (
    <Col className="@InvoiceDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          {t.logs.deletedInvoice}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay
            label="Document Number"
            value={invoice.documentNumber}
          />
          <BadgeField
            label="Status"
            value={invoiceStatusLabels[invoice.status]}
            color={getStatusColor(invoice.status)}
          />
          <FieldDisplay label="Type" value={invoiceTypeLabels[invoice.type]} />
          <FieldDisplay label="Amount" value={formatAmount()} />
          <FieldDisplay label="Facility ID" value={invoice.facilityId?.value} />
          <FieldDisplay label="Account ID" value={invoice.accountId?.value} />
        </div>
      </Col>
    </Col>
  );
};
